import React from 'react';
import { formatVisionQuota } from '../../utils/visionQuota';

/**
 * Always-visible quota line for the Visions screen and create entry points.
 */
const VisionQuotaIndicator = ({ permissions, className = '' }) => {
  const quota = formatVisionQuota(permissions);

  return (
    <p
      className={`text-label text-ink-muted ${className}`}
      aria-live="polite"
      data-testid="vision-quota-indicator"
    >
      {quota.label}
    </p>
  );
};

export default VisionQuotaIndicator;
